import styled from 'styled-components';

const NamedItem = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;

  label,
  span {
    font-size: 0.8rem;
    font-weight: 500;
    color: #7b7d8c;
    line-height: 1.1;
  }
`;

export default NamedItem;
